/**
 * lenisBus — a tiny singleton handle to the app-wide Lenis instance created in
 * SmoothScroll. Lets non-scroll code (e.g. a modal/menu) pause smooth scrolling
 * with `getLenis()?.stop()` / `.start()` without prop-drilling the instance.
 */
import type Lenis from "lenis";

let instance: Lenis | null = null;

export const setLenis = (l: Lenis | null) => { instance = l; };
export const getLenis = () => instance;
